import { memo } from 'react';
import { ICategory } from 'modules/inventory/settings/category/interfaces';
import useCategorySlugPath from 'modules/inventory/settings/category/hooks/useCategorySlugPath';
import { ReactLink } from '@dfl/react-security';
import { IconButton } from '@dfl/mui-react-common';
import { Link } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

const STORE_DOMAIN = process.env.REACT_APP_DOMAIN ?? '';

type Props = { category: ICategory };

const CategoryStoreLinkCell = ({ category }: Props) => {
  const slugPath = useCategorySlugPath(category);

  if (!slugPath) return null;

  const url = `https://${STORE_DOMAIN}/catalog/${slugPath}`;

  return (
    <ReactLink to={url} target='_blank'>
      <Box display='flex' alignItems='center' gap={0.5}>
        <IconButton tooltip={url} size='small'>
          <Link fontSize='small' />
        </IconButton>
        <Typography variant='body2' color='primary' noWrap sx={{ maxWidth: 260 }}>
          {url}
        </Typography>
      </Box>
    </ReactLink>
  );
};

export default memo(CategoryStoreLinkCell);
